<div class="main-container multi-turn-team" dir="ltr">
  <div class="multichat-header">
    <mat-tab-group
      [selectedIndex]="selectedTabIndex"
      (selectedIndexChange)="onTabIndexChange($event)"
      class="multichat-tabs"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="iq-tab-label">
            <i class="fa-solid fa-clipboard-list iq-tab-icon iq-tab-icon--summary" aria-hidden="true"></i>
            <span>Summary</span>
          </span>
        </ng-template>

        <div class="messages-container-inner">
          <div class="chat-placeholder-grid-container" *ngIf="!summarySucceeded && !summaryError && !isLoading">
            <img src="assets/img/angryguy.png" class="grid-item-logo vendor-logo" alt="Personality placeholder icon" />
            <h1 class="placeholder-title">Personality Insights</h1>
            <h1 class="placeholder-subtitle bigal-sub">Run Claude Sonnet and Writer X5 perspectives plus summary.</h1>
          </div>

          <div class="message-content" *ngIf="summarySucceeded && summary">
            <div class="markdown prism-content" [innerHTML]="formattedSummary" appCodeHighlight></div>
            <div class="export-row">
              <button class="btn-red-bigal me-3" (click)="exportToPDF()">Export to PDF</button>
              <button class="btn-red-bigal" (click)="exportToDOCX()">Export to DOCX</button>
            </div>
          </div>

          <div class="error-message" *ngIf="summaryError">{{ summaryError }}</div>
        </div>
      </mat-tab>

      <mat-tab *ngFor="let modelId of selectedModels; index as i">
        <ng-template mat-tab-label>
          <span class="iq-tab-label">
            <img [src]="getVendorLogo(modelId)" class="iq-tab-logo" alt="" />
            <span>{{ tabLabel(modelId) }}</span>
            <span *ngIf="tabStatuses[i] === 'success'" class="iq-tab-status iq-tab-status--ok" aria-label="Success">✔</span>
            <span *ngIf="tabStatuses[i] === 'error'" class="iq-tab-status iq-tab-status--err" aria-label="Error">✖</span>
          </span>
        </ng-template>

        <div class="messages-container-inner">
          <div class="chat-placeholder-grid-container" *ngIf="!rawOutputs[i] && !isLoading">
            <img [src]="getVendorLogo(modelId)" class="grid-item-logo vendor-logo" alt="" />
            <h1 class="placeholder-subtitle bigal-sub">{{ placeholderHint(modelId) }}</h1>
          </div>

          <div class="message-content" *ngIf="rawOutputs[i]">
            <div class="markdown prism-content" [innerHTML]="formattedOutputs[i]" appCodeHighlight></div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="messages-container">
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
    <div
      class="iq-submission-preview iq-submission-preview--below-loader"
      *ngIf="submittedText && (summarySucceeded || summaryError || isLoading || error)"
    >
      <div class="iq-submission-preview__label">Your submission</div>
      <div class="markdown prism-content" [innerHTML]="formattedSubmittedText" appCodeHighlight></div>
    </div>
    <div class="error-message" *ngIf="error">{{ error }}</div>
  </div>

  <div class="bottomcontainer">
    <div class="input-container">
      <div class="composer-shell">
        <div class="textarea-wrapper iq-composer">
          <textarea
            #userInputTextarea
            class="user-input-textarea"
            [(ngModel)]="inputText"
            rows="1"
            placeholder="Share a 100+ word personality prompt to analyze..."
            [disabled]="isLoading"
            (keydown)="onKeyDown($event)"
          ></textarea>
          <button
            class="btn-send-fixed"
            type="button"
            (click)="onSubmit()"
            [disabled]="isLoading || !inputText.trim()"
          >
            <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
